<template>
    <div class="mobile-news-page">
        <HeaderMobile />

        <!-- Tab切换 -->
        <div class="tab-bar">
            <div class="tab-item" :class="{ active: activeTab === 1 }" @click="switchTab(1)">市场动态</div>
            <div class="tab-item" :class="{ active: activeTab === 2 }" @click="switchTab(2)">通知公告</div>
        </div>

        <!-- 列表 -->
        <div class="list-wrap">
            <div class="loading-tip" v-if="loading">
                <i class="el-icon-loading"></i> 加载中...
            </div>

            <div class="empty-state" v-else-if="list.length === 0">
                <i class="el-icon-document"></i>
                <p>暂无相关内容</p>
            </div>

            <template v-else>
                <div class="news-item" v-for="item in list" :key="item.id" @click="goDetail(item.id)">
                    <div class="news-body">
                        <div class="news-title">{{ item.title }}</div>
                        <div class="news-summary" v-if="item.summary">{{ item.summary }}</div>
                        <div class="news-meta">
                            <span><i class="el-icon-time"></i> {{ item.create_time }}</span>
                        </div>
                    </div>
                    <img v-if="item.cover" :src="getImageUrl(item.cover)" class="news-thumb" @error="handleImgError" />
                </div>

                <!-- 加载更多 -->
                <div class="load-more" v-if="list.length < total" @click="loadMore">
                    <span v-if="!loadingMore">加载更多</span>
                    <span v-else><i class="el-icon-loading"></i> 加载中...</span>
                </div>
                <div class="no-more" v-else>没有更多了</div>
            </template>
        </div>

        <FooterMobile />

        <!-- 回到顶部 -->
        <div class="back-top" v-show="showBackTop" @click="scrollToTop">
            <i class="el-icon-arrow-up"></i>
        </div>
    </div>
</template>

<script>
import HeaderMobile from '@/components/mobile/header.vue';
import FooterMobile from '@/components/mobile/fotter.vue';
import { getNewsList } from '@/api/news';

export default {
    name: 'MobileNewsList',
    components: { HeaderMobile, FooterMobile },
    data() {
        return {
            activeTab: 1,
            list: [],
            loading: false,
            loadingMore: false,
            page: 1,
            pageSize: 10,
            total: 0,
            showBackTop: false
        };
    },
    created() {
        this.activeTab = parseInt(this.$route.query.type) || 1;
        this.fetchList();
    },
    watch: {
        '$route.query.type'(val) {
            const type = parseInt(val) || 1;
            if (this.activeTab !== type) {
                this.activeTab = type;
                this.page = 1;
                this.list = [];
                this.fetchList();
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        switchTab(type) {
            if (this.activeTab === type) return;
            this.activeTab = type;
            this.page = 1;
            this.list = [];
            this.$router.replace({ query: { type } });
            this.fetchList();
        },
        fetchList() {
            this.loading = true;
            getNewsList({ type: this.activeTab, page: this.page, limit: this.pageSize })
                .then(res => {
                    if (res.code) {
                        this.list = res.data.list || [];
                        this.total = res.data.total || 0;
                    }
                })
                .finally(() => { this.loading = false; });
        },
        loadMore() {
            this.loadingMore = true;
            this.page++;
            getNewsList({ type: this.activeTab, page: this.page, limit: this.pageSize })
                .then(res => {
                    if (res.code) {
                        this.list = this.list.concat(res.data.list || []);
                        this.total = res.data.total || 0;
                    }
                })
                .finally(() => { this.loadingMore = false; });
        },
        goDetail(id) {
            this.$router.push(`/mobile/news/${id}`);
        },
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg');
            if (url.startsWith('http://') || url.startsWith('https://')) return url;
            return process.env.VUE_APP_STATIC_URL + url;
        },
        handleImgError(e) {
            e.target.src = require('@/static/imgs/default.jpeg');
        },
        handleScroll() {
            this.showBackTop = window.scrollY > 300;
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
};
</script>

<style scoped>
.mobile-news-page {
    min-height: 100vh;
    background: #f5f5f5;
    padding-top: 60px;
}

/* Tab */
.tab-bar {
    display: flex;
    background: #fff;
    border-bottom: 1px solid #eee;
}
.tab-item {
    flex: 1;
    text-align: center;
    padding: 12px 0;
    font-size: 15px;
    color: #666;
    position: relative;
}
.tab-item.active {
    color: #e1251b;
    font-weight: 600;
}
.tab-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 24px;
    height: 3px;
    background: #e1251b;
    border-radius: 2px;
}

/* 列表 */
.list-wrap {
    padding: 10px 15px;
}
.news-item {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}
.news-body {
    flex: 1;
    min-width: 0;
}
.news-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.news-summary {
    font-size: 13px;
    color: #999;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.news-meta {
    font-size: 12px;
    color: #bbb;
}
.news-meta i {
    margin-right: 4px;
}
.news-thumb {
    width: 90px;
    height: 65px;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
}

/* 加载更多 */
.load-more {
    text-align: center;
    padding: 15px 0;
    font-size: 14px;
    color: #1890ff;
}
.load-more:active {
    opacity: 0.7;
}
.no-more {
    text-align: center;
    padding: 15px 0;
    font-size: 13px;
    color: #ccc;
}

/* 空状态 */
.empty-state {
    text-align: center;
    padding: 60px 0;
    color: #ccc;
}
.empty-state i {
    font-size: 40px;
    display: block;
    margin-bottom: 10px;
}
.empty-state p {
    font-size: 14px;
    margin: 0;
}

/* 加载中 */
.loading-tip {
    text-align: center;
    padding: 40px 0;
    font-size: 14px;
    color: #999;
}

/* 回到顶部 */
.back-top {
    position: fixed;
    right: 16px;
    bottom: 60px;
    width: 40px;
    height: 40px;
    background: rgba(0,0,0,0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}
.back-top i {
    color: #fff;
    font-size: 20px;
}
.back-top:active {
    background: rgba(0,0,0,0.7);
}
</style>
